import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { Tooltip } from 'react-tooltip';

import { SimpleFooter } from '../footer';

import { SimpleHeader } from '../../components/header';

import { Toast } from 'core/generic/components/general/toast';
import { Applicationinsights } from 'core/generic/helpers/application-insights';
import { GetSimpleFooterResponse } from 'services/idm';

type PageTemplateProps = {
    children: ReactNode;
    footerData?: GetSimpleFooterResponse;
    config?: PageTemplateConfig;
};

type PageTemplateConfig = {
    applicationInsightsConnectionString?: string;
    gtmId?: string;
};

export const PageTemplate = ({
    children,
    footerData,
    config,
}: PageTemplateProps) => {
    const { query, pathname } = useRouter();
    const isFromApp = query.fromapp !== undefined ? true : false;

    return (
        <>
            <Applicationinsights
                config={{
                    connectionString:
                        config?.applicationInsightsConnectionString,
                }}
            >
                <Toast />

                {!isFromApp && <SimpleHeader />}

                <Tooltip
                    place="top"
                    id="tooltip"
                    className="tooltip body-xsmall"
                    openEvents={{ mouseenter: true, click: true }}
                    closeEvents={{ mouseleave: true, click: true }}
                    render={({ activeAnchor }) => {
                        const title = activeAnchor?.getAttribute('data-tooltip-title');
                        const description = activeAnchor?.getAttribute('data-tooltip-description');

                        if (title || description) {
                            return (
                                <div className="tooltip__content">
                                    {title && <div className="tooltip__title bold">{title}</div>}
                                    {description && <div className="tooltip__description body-xsmall">{description}</div>}
                                </div>
                            );
                        }

                        return null;
                    }}
                />

                {children}

                {!isFromApp && (
                    <>
                        {/* TODO: Add isLogoDisplayed from API when ready */}
                        <SimpleFooter
                            data={footerData}
                        />
                    </>
                )}

                {/* {config?.gtmId && <GoogleTagManager gtmId={config.gtmId} />} */}
            </Applicationinsights>
        </>
    );
};

export default PageTemplate;
